import styled from '@emotion/styled';
import { Form } from 'antd';

export const StyleFilter = styled(Form)`
  .filter-list {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;

    .sellerType,
    .storeType {
      min-width: 160px;
    }
    .storeSelect {
      flex: 0 0 auto;
      display: inline-block;
      min-width: 160px;
      height: 32px;
      .store-selector-placeholder {
        height: auto;
      }
    }

    .action {
      flex: 0 0 auto;
      display: flex;
      justify-content: right;
      gap: 16px;
      flex: none;
    }
    .ant-input-group-wrapper {
      max-width: 20vw;
    }
    .ant-row {
      margin-bottom: 0;
    }
  }
`;
